import axios, {AxiosResponse} from 'axios'
import {IXmlTariffModel} from '../xml-tariff/XmlTariffModel'
import {ApiResponse, PageResponse} from '../../../../shared/models/ApiModels'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const XMLTARIFF_PENDING_URL = `${API_URL}api/v1/definition/xmlRate/pendingApproval`
export const XMLTARIFF_APPROVE_URL = `${API_URL}api/v1/definition/xmlRate/approve/`
export const XMLTARIFF_REJECT_URL = `${API_URL}api/v1/definition/xmlRate/reject/`

export function loadPendingApprovals(
  page = 0,
  size = 10,
  sort: string = 'createdDate',
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<IXmlTariffModel>>>> {
  return axios.get(XMLTARIFF_PENDING_URL, {
    params: {page, size, sort, order},
  })
}

export function approveXmlTariff(id: string): Promise<AxiosResponse<ApiResponse<unknown>>> {
  return axios.patch(XMLTARIFF_APPROVE_URL + encodeURIComponent(id))
}

export function rejectXmlTariff(id: string): Promise<AxiosResponse<ApiResponse<unknown>>> {
  return axios.patch(XMLTARIFF_REJECT_URL + encodeURIComponent(id))
}
